module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAFoTx1HAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATtJREFUeNpifLZVsYGBgWECE5CoB+L3AAHECBTZD2QYgEQKgVgAIIBAIv+BjAVA7ADEDxhgACixHkQDBBADVAWYZoIy+oHUBRBDAVkFHAAEECOyiJT3fRDfAeoIBSaYIJBKhCr0h1qvwIJsHlQn3CSAAAJx3oNcDcSCQMkPMO8A8UQWqAQIgBSBjG8E4g9AfJ4JyXGKUCMVoHYygHQmArE+EIOMmwDE/TDTQDrnA+0ChdYDKA2zhoEFq+/RATwkkQBAgDHi0HUAaIUjVNN+qBjIbQFQNzEw4bDEAKpJAeptEH0fiO2B2BHdxgPQ6GeA+hjmoQ9Q20DRkYDiSWiwLAQFJjSZBEJD5AHUYAw/wjQWQJ23AGrqfmjk4wQsUD/wA/FGqJgANBCQwQZQvEPZICd/xBX8Dkgp1QGbGgBkFHQcxwwnOgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/icon/wfy.png
// module id = rFWx
// module chunks = 1